import * as React from "react";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ArrowRight from "../assets/images/arrow-right.svg";
import { Modal, Box } from "@mui/material";
import closeIcon from "../assets/images/cross-close.svg";
import { FetchLogos } from "../utils/fetchUtils";
import ArrowDown from "../assets/images/down-arrow-fill.svg";
import ArrowDownInactive from "../assets/images/down-arrow-fill-inactive.svg";
import defaultLogo from "../assets/images/image.png";
import Skeleton from "@mui/material/Skeleton";
import dayjs from "dayjs";
import logo from "../assets/images/logo-1.png";
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: 24,
  height: {
    xs: "80vh",
    sm: "80vh",
    md: "80vh",
    lg: "80vh",
    xl: "80vh",
  },
  outline: "none",
  textAlign: "center",
  direction: "rtl",
};
const TableComponent = ({
  data,
  tableHeader,
  from,
  title,
  loading,
  notFoundMessage,
  carrierLogos = [],
}) => {
  const [open, setOpen] = React.useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [sortConfig, setSortConfig] = React.useState({
    key: null,
    direction: null,
  });

  const [popUpData, setPopUpData] = React.useState(null);
  const [popUpDataDetails, setPopUpDataDetails] = React.useState(null);
  const [openReccomendation, setopenReccomendation] = React.useState(false);

  const handleModalOpen = (data, logo, policyNumber, policyType) => {
    setPopUpData({
      data,
      logo,
      policyNumber,
      policyType,
    });
    const temp = {
      data,
      logo,
      policyNumber,
      policyType,
    };
    setOpen(true);
  };
  const handleModalOpenDetails = (data, logo, policyNumber, policyType) => {
    setPopUpData({
      data,
      logo,
      policyNumber,
      policyType,
    });
    setOpenDetails(true);
  };
  const handleModalClose = () => setOpen(false);
  const handleModalCloseDetails = () => setOpenDetails(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "calc(100% - 40px)",
    maxWidth: 603,
    maxHeight: "80%",
    height: "100%",
    bgcolor: "background.paper",
    borderRadius: window.innerWidth > 1024 ? "22px" : "10px",
    boxShadow: 24,
    padding: "0px",
    overflow: "auto",
  };

  // Ensure data is always an array
  const getFirstNonZeroManagementFee = (policyRow) => {
    try {
      const firstFee =
        policyRow?.PirteiTaktziv?.flatMap(
          (buget) => buget?.MivneDmeiNihul ?? []
        )
          .map((fee) => ({
            Expense: fee?.SUG_HOTZAA,
            ManagementFeeRate: fee?.SHEUR_DMEI_NIHUL,
            // dateOfRateUpdate: fee?.TAARICH_IDKUN_SHEUR_DNHL,
          }))
          .find(
            (fee) =>
              (fee.Expense === 1 || fee.Expense === "1") &&
              fee.ManagementFeeRate > 0
          )?.ManagementFeeRate ?? 0;

      console.log("First non-zero management fee:", firstFee);

      return firstFee;
    } catch (e) {
      console.error("Error in getFirstNonZeroManagementFee:", e);
      return 0;
    }
  };
  const getFirstNonZeroManagementFee2 = (policyRow) => {
    try {
      const firstFee =
        policyRow?.PirteiTaktziv?.flatMap(
          (buget) => buget?.MivneDmeiNihul ?? []
        )
          .map((fee) => ({
            Expense: fee?.SUG_HOTZAA,
            ManagementFeeRate: fee?.SHEUR_DMEI_NIHUL,
            // dateOfRateUpdate: fee?.TAARICH_IDKUN_SHEUR_DNHL,
          }))
          .find(
            (fee) =>
              (fee.Expense === 2 || fee.Expense === "2") &&
              fee.ManagementFeeRate > 0
          )?.ManagementFeeRate ?? 0;

      console.log("First non-zero management fee:", firstFee);

      return firstFee;
    } catch (e) {
      console.error("Error in getFirstNonZeroManagementFee:", e);
      return 0;
    }
  };

  // Ensure data is always an array
  const safeData = Array.isArray(data) ? data : [];

  // Filter out duplicate policies before processing
  const filteredData = safeData;

  const processedData = filteredData.map((row) => {
    if (from === "insurencePolicies") {
      return {
        logo: (() => {
          const carrier =
            carrierLogos.find((logo) => logo?._id === row?.carrier_id) ||
            carrierLogos.find((logo) => logo?._id === row?.carrier);
          return carrier && carrier?.link ? carrier.link : defaultLogo;
        })(),
        policyNumber: row?.POLICY_NUMBER,
        mainBranch: row?.MAIN_BRANCH,
        secondaryBranch: row?.Covers?.map((cover) => cover?.SECONDARY_BRANCH)
          ?.filter(Boolean)
          ?.join(", "),
        active: row?.ACTIVE == 1 ? "פעיל" : "לא פעיל",
        premiumAmount:
          row?.Covers?.reduce(
            (sum, item) => sum + parseFloat(item?.PREMIUME_AMOUNT_IN_NIS || 0),
            0
          ) || 0,
        date: row?.Covers?.[0]?.END_DATE || "-",
        premiumType: row?.Covers?.[0]?.PREMIUME_TYPE || "-",
        button:
          row?.insights &&
          row?.insights?.length &&
          row?.insights[0]?.recommendation &&
          (row?.insights[0]?.recommendation?.length ||
            row?.insights[0]?.saving > 0)
            ? row?.insights
            : [],
      };
    } else if (from === "pensionPolicies") {
      const halvaa = Array.isArray(row?.Halvaa)
        ? row?.Halvaa?.[0]
        : row?.Halvaa || {};
      const formatNumber = (value) =>
        isNaN(parseFloat(value))
          ? "-"
          : parseFloat(value).toLocaleString("he-IL", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });

      return {
        policyRef: row?.carrierName || "-",
        policyNumber: row?.MISPAR_POLISA_O_HESHBON
          ? String(row.MISPAR_POLISA_O_HESHBON).replace(/\D/g, "")
          : "-",
        loanOrder: halvaa?.MISDAR_SIDURI_SHEL_HAHALVAA || "-",
        loanAmount: formatNumber(halvaa?.SCHUM_HALVAA) || "-",
        remainingLoan: formatNumber(halvaa?.YITRAT_HALVAA) || "-",
        interestRate: halvaa?.RIBIT || "-",
        loanReceivedDate: halvaa?.TAARICH_KABALAT_HALVAA || "-",
        loanEndDate: halvaa?.TAARICH_SIYUM_HALVAA || "-",
        repaymentFrequency:
          halvaa?.TADIRUT_HECHZER_HALVAA == 1
            ? "תשלום חודשי"
            : halvaa?.TADIRUT_HECHZER_HALVAA == 2
            ? "תשלום רבעוני"
            : halvaa?.TADIRUT_HECHZER_HALVAA == 3
            ? "תשלום חצי שנתי"
            : halvaa?.TADIRUT_HECHZER_HALVAA == 4
            ? "תשלום שנתי"
            : halvaa?.TADIRUT_HECHZER_HALVAA == 5
            ? "אחר"
            : "-",
        loanPeriod: halvaa?.TKUFAT_HALVAA || "-",
        periodicRepayment: halvaa?.SCHUM_HECHZER_TKUFATI || "-",
        interestType:
          halvaa?.SUG_RIBIT == 1
            ? "קבועה"
            : halvaa?.SUG_RIBIT == 2
            ? "משתנה"
            : "-",
        indexationType:
          halvaa?.SUG_HATZNMADA == 1
            ? "לא צמוד"
            : halvaa?.SUG_HATZNMADA == 2
            ? "צמוד למדד חודשי"
            : halvaa?.SUG_HATZNMADA == 3
            ? "צמוד למדד חצי שנתי"
            : halvaa?.SUG_HATZNMADA == 4
            ? "אחר"
            : "-",
        repaymentType:
          halvaa?.SUG_HECHZER == "1"
            ? "שפיצר"
            : halvaa?.SUG_HECHZER == "2"
            ? "ריבית שוטפת"
            : "-",
        date: row.TAARICH_NECHONUT || "_",
      };
    } else if (from === "financePension") {
      return {
        logo: (() => {
          const carrier =
            carrierLogos.find((logo) => logo?._id === row?.carrier_id) ||
            carrierLogos.find((logo) => logo?._id === row?.carrier);
          return carrier && carrier?.link ? carrier.link : defaultLogo;
        })(),
        field1: row?.productTypeName || row?.SHEM_TOCHNIT || "-",
        field2: row?.MISPAR_POLISA_O_HESHBON
          ? String(row.MISPAR_POLISA_O_HESHBON).replace(/\D/g, "")
          : "-",
        field3: row?.STATUS_POLISA_O_CHESHBON || "-",
        field4: (() => {
          const sum =
            row?.PirteiTaktziv?.flatMap(
              (item) => item?.PerutYitrot || []
            )?.reduce((acc, curr) => {
              return acc + parseFloat(curr?.TOTAL_CHISACHON_MTZBR || 0);
            }, 0) || 0;
          return sum?.toLocaleString("he-IL") || "0";
        })(),
        field5: (() => {
          const latestDateStr = row?.PirteiTaktziv?.map(
            (item) => item?.NesilutTag?.MOED_NEZILUT_TAGMULIM
          )
            ?.filter(Boolean)
            ?.sort((a, b) => b.localeCompare(a))?.[0];

          return latestDateStr
            ? dayjs(latestDateStr).format("YYYY-MM-DD")
            : null;
        })(),

        // field6a: row.PirteiTaktziv[0].HotzaotBafoalLehodeshDivoach.SHEUR_DMEI_NIHUL_TZVIRA,
        // field6b: row.PirteiTaktziv[0].HotzaotBafoalLehodeshDivoach.SHEUR_DMEI_NIHUL_HAFKADA,
        field6: getFirstNonZeroManagementFee(row),

        field7: (() => {
          if (row?.STATUS_POLISA_O_CHESHBON === "1") {
            const sum =
              row?.PirteiTaktziv?.reduce((total, item) => {
                const value = parseFloat(
                  item?.HotzaotBafoalLehodeshDivoach
                    ?.TOTAL_DMEI_NIHUL_POLISA_O_HESHBON || 0
                );
                return total + value;
              }, 0) || 0;

            return sum.toLocaleString("he-IL");
          } else {
            const sum =
              row?.PirteiTaktziv?.reduce((total, item) => {
                const value = parseFloat(
                  item?.HotzaotBafoalLehodeshDivoach
                    ?.TOTAL_DMEI_NIHUL_POLISA_O_HESHBON || 0
                );
                return total + value;
              }, 0) || 0;

            return sum.toLocaleString("he-IL");
          }
          // else {
          //   const sum =
          //     row?.PirteiTaktziv?.reduce((total, item) => {
          //       const values = item?.MivneDmeiNihul || [];
          //       const validEntries = values.filter(
          //         (entry) => parseFloat(entry.SHEUR_DMEI_NIHUL) > 0
          //       );
          //       if (validEntries.length === 0) return total;
          //       const latestDate = validEntries.reduce((maxDate, curr) => {
          //         return !maxDate || curr.TAARICH_IDKUN_SHEUR_DNHL > maxDate
          //           ? curr.TAARICH_IDKUN_SHEUR_DNHL
          //           : maxDate;
          //       }, null);
          //       const latestEntries = validEntries.filter(
          //         (entry) => entry.TAARICH_IDKUN_SHEUR_DNHL === latestDate
          //       );
          //       const bestEntry = latestEntries.reduce((max, curr) => {
          //         const currVal = parseFloat(curr.SHEUR_DMEI_NIHUL);
          //         const maxVal = parseFloat(max?.SHEUR_DMEI_NIHUL || 0);
          //         return currVal > maxVal ? curr : max;
          //       }, null);
          //       const value = parseFloat(bestEntry?.SHEUR_DMEI_NIHUL || 0);
          //       return total + value;
          //     }, 0) || 0;
          //   return sum.toLocaleString("he-IL");
          // }
        })(),

        field8: row?.Tsua?.SHEUR_TSUA_NETO || 0,
        field9: (() => {
          const sum =
            row?.PirteiTaktziv?.flatMap(
              (item) => item?.PerutHafrashotLePolisa || []
            )
              ?.filter((item) => item?.SUG_HAMAFKID === "1")
              ?.reduce(
                (acc, curr) => acc + parseFloat(curr?.SCHUM_HAFRASHA || 0),
                0
              ) || 0;

          return sum?.toLocaleString("he-IL") || "0";
        })(),
        field10: (() => {
          const sum =
            row?.PirteiTaktziv?.flatMap(
              (item) => item?.PerutHafrashotLePolisa || []
            )
              ?.filter((entry) => entry?.SUG_HAMAFKID === "2")
              ?.reduce(
                (acc, curr) => acc + parseFloat(curr?.SCHUM_HAFRASHA || 0),
                0
              ) || 0;

          return sum?.toLocaleString("he-IL") || "0";
        })(),
        field11: row?.TAARICH_HITZTARFUT_MUTZAR || 0,
        field13: row.TAARICH_NECHONUT || "_",
        button:
          row?.insights &&
          row?.insights?.length &&
          row?.insights[0]?.recommendation &&
          (row?.insights[0]?.recommendation?.length ||
            row?.insights[0]?.saving > 0)
            ? row?.insights
            : [],
        productType: row?.productTypeName,
        statusName: row?.statusName,
      };
    } else if (from === "savingPageOrig") {
      const allHafkadaEntries =
        row?.PirteiTaktziv?.flatMap(
          (item) => item?.PerutPirteiHafkadaAchrona || []
        ) || [];
      const currentYear = new Date().getFullYear();

      const currentYearEntries = allHafkadaEntries.filter((entry) => {
        const entryDate = new Date(entry?.TAARICH_ERECH_HAFKADA || 0);
        return entryDate.getFullYear() === currentYear;
      });

      const latestDate = currentYearEntries.reduce((latest, current) => {
        const currentDate = new Date(current?.TAARICH_ERECH_HAFKADA || 0);
        return currentDate > latest ? currentDate : latest;
      }, new Date(0));

      const latestEntries = currentYearEntries.filter((entry) => {
        return (
          new Date(entry?.TAARICH_ERECH_HAFKADA || 0).getTime() ===
          latestDate.getTime()
        );
      });

      const latestTotalHafkada = parseFloat(
        latestEntries[0]?.TOTAL_HAFKADA || 0
      );

      return {
        logo: (() => {
          const carrier =
            carrierLogos.find((logo) => logo?._id === row?.carrier_id) ||
            carrierLogos.find((logo) => logo?._id === row?.carrier);
          return carrier && carrier?.link ? carrier.link : defaultLogo;
        })(),
        field1: row?.MISPAR_POLISA_O_HESHBON
          ? String(row.MISPAR_POLISA_O_HESHBON).replace(/\D/g, "")
          : "-",
        field2: row?.productTypeName || "-",
        field3: row?.STATUS_POLISA_O_CHESHBON || "-",
        field4: (() => {
          const currentYear = dayjs().year();
          const sum =
            row?.PirteiTaktziv?.flatMap(
              (item) => item?.PerutHafkadotMetchilatShana || []
            )
              ?.filter(
                (entry) =>
                  dayjs(entry?.TAARICH_ERECH_HAFKADA).year() === currentYear
              )
              ?.reduce(
                (acc, curr) =>
                  acc + parseFloat(curr?.SCHUM_HAFKADA_SHESHULAM || 0),
                0
              ) || 0;

          return sum?.toLocaleString("he-IL") || "0";
        })(),
        field5:
          parseFloat(latestTotalHafkada || 0).toLocaleString("he-IL", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) || 0,
        field6:
          row?.PirteiTaktziv?.reduce((total, taktzi) => {
            const sumForTaktzi =
              taktzi?.PerutYitrot?.reduce(
                (sum, item) =>
                  sum + parseFloat(item.TOTAL_CHISACHON_MTZBR || 0),
                0
              ) || 0;
            return total + sumForTaktzi;
          }, 0)?.toLocaleString("he-IL", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) || 0,
        field7: row?.Tsua?.SHEUR_TSUA_NETO || 0,
        //         field8a: row.PirteiTaktziv[0].HotzaotBafoalLehodeshDivoach.SHEUR_DMEI_NIHUL_TZVIRA,
        // field8b: row.PirteiTaktziv[0].HotzaotBafoalLehodeshDivoach.SHEUR_DMEI_NIHUL_HAFKADA,
        field8: getFirstNonZeroManagementFee(row),

        field10: row.TAARICH_NECHONUT,

        button:
          row?.insights &&
          row?.insights?.length &&
          row?.insights[0]?.recommendation &&
          (row?.insights[0]?.recommendation?.length ||
            row?.insights[0]?.saving > 0)
            ? row?.insights
            : [],
        productType: row?.productTypeName,
        statusName: row?.statusName,
      };
    } else if (from === "savingPage") {
      const allHafkadaEntries =
        row?.PirteiTaktziv?.flatMap(
          (item) => item.PerutPirteiHafkadaAchrona || []
        ) || [];
      const currentYear = new Date().getFullYear();

      const currentYearEntries = allHafkadaEntries.filter((entry) => {
        const entryDate = new Date(entry.TAARICH_ERECH_HAFKADA);
        return entryDate.getFullYear() === currentYear;
      });

      const latestDate = currentYearEntries.reduce((latest, current) => {
        const currentDate = new Date(current.TAARICH_ERECH_HAFKADA);
        return currentDate > latest ? currentDate : latest;
      }, new Date(0));

      const latestEntries = currentYearEntries.filter((entry) => {
        return (
          new Date(entry.TAARICH_ERECH_HAFKADA).getTime() ===
          latestDate.getTime()
        );
      });

      const latestTotalHafkada = parseFloat(
        latestEntries[0]?.TOTAL_HAFKADA || 0
      );

      return {
        logo: (() => {
          const carrier =
            carrierLogos.find((logo) => logo?._id === row?.carrier_id) ||
            carrierLogos.find((logo) => logo?._id === row?.carrier);
          return carrier && carrier?.link ? carrier.link : defaultLogo;
        })(),
        field1: row?.MISPAR_POLISA_O_HESHBON
          ? String(row.MISPAR_POLISA_O_HESHBON).replace(/\D/g, "")
          : "-",
        field2: row.productTypeName || "-",
        field3: row.STATUS_POLISA_O_CHESHBON || "-",
        field11: (() => {
          const pensionFundTypeMap = { "1": "יסוד", "2": "מקיפה", "3": "כללית" };
          const key = String(row?.SUG_KEREN_PENSIA || "");
          return pensionFundTypeMap[key] || "-";
        })(),
        field4: (() => {
          const currentYear = dayjs().year();
          const sum = row?.PirteiTaktziv?.flatMap(
            (item) => item?.PerutHafkadotMetchilatShana || []
          )
            ?.filter(
              (entry) =>
                dayjs(entry?.TAARICH_ERECH_HAFKADA).year() === currentYear
            )
            ?.reduce(
              (acc, curr) =>
                acc + parseFloat(curr?.SCHUM_HAFKADA_SHESHULAM || 0),
              0
            );

          return sum.toLocaleString("he-IL");
        })(),
        field5:
          parseFloat(latestTotalHafkada || 0).toLocaleString("he-IL", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) || 0,
        // field6:
        //   row?.PerutYitrot?.reduce(
        //     (sum, item) => sum + parseFloat(item.TOTAL_CHISACHON_MTZBR),
        //     0
        //   ) || 0,
        field6: row?.Tsua?.SHEUR_TSUA_NETO || "-",
        // field7:
        //   (
        //     row?.PirteiTaktziv?.reduce((total, taktzi) => {
        //       const sumForTaktzi =
        //         taktzi?.MivneDmeiNihul?.reduce(
        //           (sum, item) => sum + parseFloat(item.SHEUR_DMEI_NIHUL || 0),
        //           0
        //         ) || 0;
        //       return total + sumForTaktzi;
        //     }, 0) / row?.PirteiTaktziv?.length
        //   )?.toFixed(2) || 0,

        field7a: getFirstNonZeroManagementFee(row),
        field7b: getFirstNonZeroManagementFee2(row),

        field10: row.TAARICH_NECHONUT,
        statusName: row?.statusName,
        button:
          row?.insights &&
          row?.insights?.length &&
          row?.insights[0]?.recommendation &&
          (row?.insights[0]?.recommendation?.length ||
            row?.insights[0]?.saving > 0)
            ? row?.insights
            : [],
        productType: row?.productTypeName,
      };
    } else if (from === "recommendations") {
      return {
        logo: (() => {
          const carrier =
            carrierLogos.find((logo) => logo?._id === row?.carrier_id) ||
            carrierLogos.find((logo) => logo?._id === row?.carrier);
          return carrier && carrier.link ? carrier.link : defaultLogo;
        })(),
        policyNumber: row.policy_number,
        recommendation: row.recommendation,
        policyDetails: row.policyDetails,
        from: row.from,
        estimatedSavings: `${row.saving || 0}`,
      };
    } else if (from === "recommendations1") {
      return {
        recommendedCoverage: row.product_name,
        explanationRecommendation: row.recommendation,
        estimatedCost: `₪${row.annualy_fee || 0}`,
      };
    }
    return row;
  });

  const getSortIcon = (key) => {
    const isActive = sortConfig.key === key;
    const isAscending = sortConfig.direction === "ascending";

    return (
      <span className="table-fillter">
        <img
          src={isActive && !isAscending ? ArrowDown : ArrowDownInactive}
          alt="Arrow Up"
          className="table-arrow-up"
          onClick={() => requestSort(key)}
          style={{ cursor: "pointer" }}
        />
        <img
          src={isActive && isAscending ? ArrowDown : ArrowDownInactive}
          alt="Arrow Down"
          className="table-arrow-down"
          onClick={() => requestSort(key)}
          style={{ cursor: "pointer" }}
        />
      </span>
    );
  };
  const requestSort = (key, sortable) => {
    if (sortable) {
      setSortConfig((prev) => {
        if (prev.key === key && prev.direction === "ascending") {
          return { key, direction: "descending" };
        }
        return { key, direction: "ascending" };
      });
    }
  };

  const sortRows = (rows) => {
    if (!sortConfig.key) return rows;

    return [...rows].sort((a, b) => {
      const { key, direction } = sortConfig;

      const parseDate = (val) => {
        if (!val) return null;

        if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
          return new Date(val);
        }

        if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) {
          const [day, month, year] = val.split("/").map(Number);
          return new Date(year, month - 1, day);
        }

        return null;
      };

      const getComparableValue = (val) => {
        const date = parseDate(val);
        if (date) return date.getTime();
        if (!isNaN(parseFloat(val))) return parseFloat(val);
        return val;
      };

      const valueA = getComparableValue(a[key]);
      const valueB = getComparableValue(b[key]);

      const isDateA = typeof valueA === "number" && parseDate(a[key]);
      const isDateB = typeof valueB === "number" && parseDate(b[key]);

      // If only one is a valid date, push the other
      if (isDateA && !isDateB) return direction === "ascending" ? -1 : 1;
      if (!isDateA && isDateB) return direction === "ascending" ? 1 : -1;

      if (valueA < valueB) return direction === "ascending" ? -1 : 1;
      if (valueA > valueB) return direction === "ascending" ? 1 : -1;
      return 0;
    });
  };
  const handleModalOpenReccomendation = (
    logo,
    policyNumber,
    policyDetails,
    from,
    estimatedSavings,
    recommendation
  ) => {
    setPopUpDataDetails({
      logo,
      policyNumber,
      policyDetails,
      from,
      estimatedSavings,
      recommendation,
    });
  

    setopenReccomendation(true);
  };
  const handleClose = () => {
    setopenReccomendation(false);
  };
  const sortedData = sortRows(processedData || []);

  return (
    <>
      <div className="table-main table-sort-main sort-fillter">
        <div className="title d-flex justify-content-between">
          <h2>{title}</h2>
        </div>
        {sortedData.length === 0 ? (
          title !== "ביטוחי רכב דירה עסק" ? (
            <Skeleton
              variant="rectangular"
              width="100%"
              height={500}
              animation="wave"
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.05)",
                borderRadius: 1,
                marginBottom: 2,
              }}
            />
          ) : (
            <Skeleton
              variant="rectangular"
              width="100%"
              height={200}
              animation="wave"
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.05)",
                borderRadius: 1,
                marginBottom: 2,
              }}
            />
          )
        ) : (
          <div className="table-wrapper">
            {(from == "pensionPolicies" &&
              sortedData.filter((item) => item.loanAmount != "-") &&
              sortedData.filter((item) => item.loanAmount != "-").length) ||
            (from != "pensionPolicies" && sortedData && sortedData.length) ? (
              <TableContainer component={Paper}>
                <Table aria-label="custom table">
                  <TableHead>
                    <TableRow
                      className={
                        from === "insurencePolicies" ||
                        from === "pensionPolicies" ||
                        from === "savingPage" ||
                        from === "savingPageOrig" ||
                        from === "financePension"
                          ? "row_with_logos_td"
                          : ""
                      }
                    >
                      {tableHeader.map((item, index) => (
                        <TableCell
                          key={index}
                          onClick={() =>
                            requestSort(item.engTrns, item.sortable)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {item.sortable && getSortIcon(item.engTrns)}{" "}
                          {item.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedData.length > 0 &&
                      (from === "pensionPolicies"
                        ? sortedData.filter((item) => item.loanAmount != "-")
                        : sortedData
                      ).map((row, index) => (
                        <TableRow key={index}>
                          {from === "insurencePolicies" && (
                            <>
                              <TableCell>
                                <img
                                  src={row.logo || defaultLogo}
                                  alt="logo"
                                  style={{ height: 30 }}
                                />
                              </TableCell>
                              {window.innerWidth < 767 && (
                                <>
                                  <TableCell>
                                    {row.premiumType == "2"
                                      ? "חודשית"
                                      : "שנתית"}
                                  </TableCell>
                                  <TableCell data-label="סוג פרמיה:">
                                    <Button
                                      className={`${
                                        row?.button && row?.button?.length === 0
                                          ? "disabled-btn button-arrow"
                                          : "button-arrow"
                                      }`}
                                      variant="outlined"
                                      size="small"
                                      style={{ textTransform: "none" }}
                                      onClick={() =>
                                        handleModalOpen(
                                          row?.button && row?.button?.length
                                            ? row?.button
                                            : [],
                                          row.logo,
                                          row.policyNumber,
                                          row.mainBranch
                                        )
                                      }
                                      disabled={
                                        row?.button && row?.button?.length === 0
                                      }
                                    >
                                      המלצות לשיפור
                                      <img src={ArrowRight} alt="logo" />
                                    </Button>
                                  </TableCell>
                                </>
                              )}
                              <TableCell>{row.policyNumber}</TableCell>
                              <TableCell>{row.mainBranch}</TableCell>
                              <TableCell title={row.secondaryBranch}>
                                {row.secondaryBranch}
                              </TableCell>

                              {/* <TableCell>{row.tag}</TableCell> */}

                              <TableCell>
                                <span
                                  className={
                                    row.active === "פעיל"
                                      ? "green-tag"
                                      : "red-tag"
                                  }
                                >
                                  {row.active}
                                </span>
                              </TableCell>
                              <TableCell>
                                ₪
                                {row?.premiumAmount?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </TableCell>
                              <TableCell>{row.date}</TableCell>

                              {window.innerWidth > 767 && (
                                <>
                                  <TableCell>
                                    {row.premiumType == "2"
                                      ? "חודשית"
                                      : "שנתית"}
                                  </TableCell>

                                  <TableCell data-label="סוג פרמיה:">
                                    <Button
                                      className={`${
                                        row?.button && row?.button?.length === 0
                                          ? "disabled-btn button-arrow"
                                          : "button-arrow"
                                      }`}
                                      variant="outlined"
                                      size="small"
                                      style={{ textTransform: "none" }}
                                      onClick={() =>
                                        handleModalOpen(
                                          row?.button && row?.button?.length
                                            ? row?.button
                                            : [],
                                          row.logo,
                                          row.policyNumber,
                                          row.mainBranch
                                        )
                                      }
                                      disabled={
                                        row?.button && row?.button?.length === 0
                                      }
                                    >
                                      המלצות לשיפור
                                      <img src={ArrowRight} alt="logo" />
                                    </Button>
                                  </TableCell>
                                </>
                              )}
                            </>
                          )}
                          {from === "pensionPolicies" && (
                            <>
                              <TableCell>{row.policyRef}</TableCell>
                              <TableCell>{row.policyNumber}</TableCell>
                              <TableCell>{row.loanOrder}</TableCell>
                              <TableCell>₪{row.loanAmount}</TableCell>
                              <TableCell>₪{row.remainingLoan}</TableCell>
                              <TableCell style={{ direction: "ltr" }}>
                                {row.interestRate}%
                              </TableCell>
                              <TableCell>{row.loanReceivedDate}</TableCell>
                              <TableCell>{row.loanEndDate}</TableCell>
                              <TableCell>{row.repaymentFrequency}</TableCell>
                              <TableCell>{row.loanPeriod}</TableCell>
                              <TableCell>{row.periodicRepayment}</TableCell>
                              <TableCell>{row.interestType}</TableCell>
                              <TableCell>{row.indexationType}</TableCell>
                              <TableCell>{row.repaymentType}</TableCell>
                              <TableCell>{row.date}</TableCell>
                            </>
                          )}
                          {from === "savingPage" && (
                            <>
                              <TableCell>
                                <img
                                  src={row?.logo || defaultLogo}
                                  alt="logo"
                                  style={{ height: 30 }}
                                />
                              </TableCell>

                              <TableCell>{row.field1}</TableCell>
                              {window.innerWidth < 767 ? (
                                <TableCell data-label="סוג פרמיה:">
                                  <Button
                                    className={`${
                                      row?.button && row?.button?.length === 0
                                        ? "disabled-btn button-arrow"
                                        : "button-arrow"
                                    }`}
                                    variant="outlined"
                                    size="small"
                                    style={{ textTransform: "none" }}
                                    onClick={() =>
                                      handleModalOpen(
                                        row?.button && row?.button?.length
                                          ? row?.button
                                          : [],
                                        row.logo,
                                        row.field1,
                                        row.productType
                                      )
                                    }
                                    disabled={
                                      row?.button && row?.button?.length === 0
                                    }
                                  >
                                    המלצות לשיפור
                                    <img src={ArrowRight} alt="logo" />
                                  </Button>
                                </TableCell>
                              ) : null}
                              <TableCell>{row.field2}</TableCell>
                              <TableCell>
                                <span
                                  className={
                                    row.field3 === "1"
                                      ? "green-tag"
                                      : "grey-tag"
                                  }
                                >
                                  {/* {row.field3 == "1" ? "פעיל" : "לא פעיל"} */}
                                  {row.statusName
                                    ? row.statusName
                                    : row.field3 == "2" || row.field3 == "3"
                                    ? "לא פעיל"
                                    : "פעיל"}
                                </span>
                              </TableCell>
                              <TableCell>{row.field11}</TableCell>
                              <TableCell>₪{row.field4}</TableCell>
                              <TableCell>₪{row.field5}</TableCell>
                              <TableCell style={{ direction: "ltr" }}>
                                {row.field6}%
                              </TableCell>
                              <TableCell style={{ direction: "ltr" }}>
                                {row.field7a}%
                              </TableCell>
                              <TableCell style={{ direction: "ltr" }}>
                                {row.field7b}%
                              </TableCell>
                              <TableCell>{row.field10}</TableCell>
                              {/* <TableCell>{row.field8}</TableCell> */}
                              {window.innerWidth > 767 ? (
                                <TableCell data-label="סוג פרמיה:">
                                  <Button
                                    className={`${
                                      row?.button && row?.button?.length === 0
                                        ? "disabled-btn button-arrow"
                                        : "button-arrow"
                                    }`}
                                    variant="outlined"
                                    size="small"
                                    style={{ textTransform: "none" }}
                                    onClick={() =>
                                      handleModalOpen(
                                        row?.button && row?.button?.length
                                          ? row?.button
                                          : [],
                                        row.logo,
                                        row.field1,
                                        row.productType
                                      )
                                    }
                                    disabled={
                                      row?.button && row?.button?.length === 0
                                    }
                                  >
                                    המלצות לשיפור
                                    <img src={ArrowRight} alt="logo" />
                                  </Button>
                                </TableCell>
                              ) : null}
                            </>
                          )}
                          {from === "savingPageOrig" && (
                            <>
                              <TableCell>
                                <img
                                  src={row?.logo || defaultLogo}
                                  alt="logo"
                                  style={{ height: 30 }}
                                />
                              </TableCell>

                              <TableCell>{row.field1}</TableCell>
                              {window.innerWidth < 767 ? (
                                <TableCell data-label="סוג פרמיה:">
                                  <Button
                                    className={`${
                                      row?.button && row?.button?.length === 0
                                        ? "disabled-btn button-arrow"
                                        : "button-arrow"
                                    }`}
                                    variant="outlined"
                                    size="small"
                                    style={{ textTransform: "none" }}
                                    onClick={() =>
                                      handleModalOpen(
                                        row?.button && row?.button?.length
                                          ? row?.button
                                          : [],
                                        row.logo,
                                        row.field1,
                                        row.productType
                                      )
                                    }
                                    disabled={
                                      row?.button && row?.button?.length === 0
                                    }
                                  >
                                    המלצות לשיפור
                                    <img src={ArrowRight} alt="logo" />
                                  </Button>
                                </TableCell>
                              ) : null}
                              <TableCell>{row.field2}</TableCell>
                              <TableCell>
                                <span
                                  className={
                                    row.field3 === "1"
                                      ? "green-tag"
                                      : "grey-tag"
                                  }
                                >
                                  {row.statusName
                                    ? row.statusName
                                    : row.field3 == "2" || row.field3 == "3"
                                    ? "לא פעיל"
                                    : "פעיל"}
                                </span>
                              </TableCell>
                              <TableCell>₪{row.field4}</TableCell>
                              <TableCell>₪{row.field5}</TableCell>
                              <TableCell>₪{row.field6}</TableCell>
                              <TableCell style={{ direction: "ltr" }}>
                                {row.field7}%
                              </TableCell>
                              <TableCell style={{ direction: "ltr" }}>
                                {row.field8}%
                              </TableCell>
                              <TableCell>{row.field10}</TableCell>
                              {window.innerWidth > 767 ? (
                                <TableCell data-label="סוג פרמיה:">
                                  <Button
                                    className={`${
                                      row?.button && row?.button?.length === 0
                                        ? "disabled-btn button-arrow"
                                        : "button-arrow"
                                    }`}
                                    variant="outlined"
                                    size="small"
                                    style={{ textTransform: "none" }}
                                    onClick={() =>
                                      handleModalOpen(
                                        row?.button && row?.button?.length
                                          ? row?.button
                                          : [],
                                        row.logo,
                                        row.field1,
                                        row.productType
                                      )
                                    }
                                    disabled={
                                      row?.button && row?.button?.length === 0
                                    }
                                  >
                                    המלצות לשיפור
                                    <img src={ArrowRight} alt="logo" />
                                  </Button>
                                </TableCell>
                              ) : null}
                            </>
                          )}
                          {from === "financePension" && (
                            <>
                              <TableCell>
                                <img
                                  src={row?.logo || defaultLogo}
                                  alt="logo"
                                  style={{ height: 30 }}
                                />
                              </TableCell>

                              <TableCell style={{ wordBreak: "break-word" }}>
                                {row.field1}
                              </TableCell>
                              {window.innerWidth < 767 ? (
                                <TableCell data-label="סוג פרמיה:">
                                  <Button
                                    className={`${
                                      row?.button && row?.button?.length === 0
                                        ? "disabled-btn button-arrow"
                                        : "button-arrow"
                                    }`}
                                    variant="outlined"
                                    size="small"
                                    style={{ textTransform: "none" }}
                                    
                                    onClick={() =>
                                      handleModalOpen(
                                        row?.button && row?.button?.length
                                          ? row?.button
                                          : [],
                                        row.logo,
                                        row.field1,
                                        row.productType
                                      )
                                      
                                    }
                                    disabled={
                                      row?.button && row?.button?.length === 0
                                    }
                                  >
                                    המלצות לשיפור
                                    <img src={ArrowRight} alt="logo" />
                                  </Button>
                                </TableCell>
                              ) : null}
                              <TableCell>{row.field2}</TableCell>
                              <TableCell>
                                <span
                                  className={
                                    row.field3 === "1"
                                      ? "green-tag"
                                      : "grey-tag"
                                  }
                                >
                                  {/* {row.field3 == "1" ? "פעיל" : "לא פעיל"} */}
                                  {row.statusName
                                    ? row.statusName
                                    : row.field3 == "2" || row.field3 == "3"
                                    ? "לא פעיל"
                                    : "פעיל"}
                                </span>
                              </TableCell>
                              <TableCell>₪{row.field4}</TableCell>
                              <TableCell>{row.field5}</TableCell>
                              <TableCell style={{ direction: "ltr" }}>
                                {row.field6}%
                              </TableCell>
                              {/* <TableCell>{row.field7}</TableCell> */}
                              <TableCell>₪{row.field7}</TableCell>
                              <TableCell style={{ direction: "ltr" }}>
                                {row.field8}%
                              </TableCell>
                              <TableCell>{row.field9}</TableCell>
                              <TableCell>₪{row.field10}</TableCell>
                              <TableCell>{row.field11}</TableCell>
                              <TableCell>{row.field13}</TableCell>
                              {window.innerWidth > 767 ? (
                                <TableCell data-label="סוג פרמיה:">
                                  <Button
                                    className={`${
                                      row?.button && row?.button?.length === 0
                                        ? "disabled-btn button-arrow"
                                        : "button-arrow"
                                    }`}
                                    variant="outlined"
                                    size="small"
                                    style={{ textTransform: "none" }}
                                    onClick={() =>
                                      handleModalOpen(
                                        row?.button && row?.button?.length
                                          ? row?.button
                                          : [],
                                        row.logo,
                                        row.field2,
                                        row.productType
                                      )
                                    }
                                    disabled={
                                      row?.button && row?.button?.length === 0
                                    }
                                  >
                                    המלצות לשיפור
                                    <img src={ArrowRight} alt="logo" />
                                  </Button>
                                </TableCell>
                              ) : null}
                            </>
                          )}
                          {from === "recommendations" && (
                            <>
                              <TableCell>
                                <img
                                  src={row?.logo || defaultLogo}
                                  alt="logo"
                                  style={{ height: 30 }}
                                />
                              </TableCell>
                              <TableCell style={{ wordBreak: "break-word" }}>
                                {String(row.policyNumber).replace(/\D/g, '')}
                              </TableCell>
                              {/* <TableCell>{row.insuranceType}</TableCell> */}
                              <TableCell>{row.recommendation}</TableCell>
                              <TableCell>₪{row.estimatedSavings}</TableCell>
                              <TableCell data-label="סוג פרמיה:">
                                <span className="button-group d-flex">
                                  <Button
                                    className={`${
                                      row?.button && row?.button?.length === 0
                                        ? "disabled-btn button-arrow"
                                        : "button-arrow"
                                    }`}
                                    variant="outlined"
                                    size="small"
                                    style={{ textTransform: "none" }}
                                    onClick={() =>
                                      handleModalOpen(
                                        [
                                          {
                                            recommendation: Array.isArray(
                                              row.recommendation
                                            )
                                              ? row.recommendation
                                              : [row.recommendation],
                                            saving: row.estimatedSavings ?? 0,
                                          },
                                        ],
                                        row.logo,
                                        row.policyNumber,
                                        row.policyDetails?.productTypeName ||
                                          row.policyDetails?.MAIN_BRANCH
                                      )
                                    }
                                    disabled={
                                      row?.button && row?.button?.length === 0
                                    }
                                  >
                                    צפה בהצעה לשיפור
                                    <img src={ArrowRight} alt="logo" />
                                  </Button>
                                  {/* <Button
                                    className={`${
                                      row?.button && row?.button?.length === 0
                                        ? "disabled-btn button-arrow"
                                        : "button-arrow"
                                    }`}
                                    variant="outlined"
                                    size="small"
                                    style={{ textTransform: "none" }}
                                    onClick={() =>
                                      handleModalOpenDetails(
                                        row,
                                        row.logo,
                                        row.policyNumber,
                                        row.policyType
                                      )
                                    }
                                    disabled={
                                      row?.button && row?.button?.length === 0
                                    }
                                  >
                                    צפה בפוליסה
                                    <img src={ArrowRight} alt="logo" />
                                  </Button> */}
                                </span>
                              </TableCell>
                            </>
                          )}
                          {from === "recommendations1" && (
                            <>
                              <TableCell style={{ wordBreak: "break-word" }}>
                                {row.recommendedCoverage}
                              </TableCell>
                              <TableCell>
                                {row.explanationRecommendation}
                              </TableCell>
                              <TableCell>{row.estimatedCost}</TableCell>
                              <TableCell data-label="סוג פרמיה:">
                                <span className="button-group d-flex">
                                  {/* <Button
                                    className={`${
                                      row?.button && row?.button?.length === 0
                                        ? "disabled-btn button-arrow"
                                        : "button-arrow"
                                    }`}
                                    variant="outlined"
                                    size="small"
                                    style={{ textTransform: "none" }}
                                    onClick={() =>
                                      handleModalOpenReccomendation()
                                    }
                                    disabled={
                                      row?.button && row?.button?.length === 0
                                    }
                                  >
                                    השוואת הצעות
                                    <img src={ArrowRight} alt="logo" />
                                  </Button> */}
                                  <Button
                                    className={`${
                                      row?.button && row?.button?.length === 0
                                        ? "disabled-btn button-arrow"
                                        : "button-arrow"
                                    }`}
                                    variant="outlined"
                                    size="small"
                                    style={{ textTransform: "none" }}
                                    onClick={() =>
                                      handleModalOpenReccomendation()
                                    }
                                    disabled={
                                      row?.button && row?.button?.length === 0
                                    }
                                  >
                                    קבל הצעה לפוליסה
                                    <img src={ArrowRight} alt="logo" />
                                  </Button>
                                </span>
                              </TableCell>
                            </>
                          )}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <div style={{ display: "flex", height: "200px" }}>
                <div style={{ margin: "auto" }}>
                  מצטערים, לא מצאנו שום נתונים הקשורים {notFoundMessage}.
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      {/* Modal */}
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="tmMain" sx={style}>
          <div className="table_modal_main">
            <div className="tm_sticky">
              <div className="tm_logo">
                <span className="em_brand_info">
                  <img src={popUpData?.logo || defaultLogo} alt="brand logo" />
                </span>
                <span className="em_close">
                  <img onClick={handleModalClose} src={closeIcon} alt="close" />
                </span>
              </div>
              <div className="tm_info_main">
                <div className="tm_info">
                  <h4>מספר פוליסה</h4>
                  <p>{popUpData?.policyNumber?.replace(/\D/g, "")}</p>
                </div>
                <div className="tm_info">
                  <h4>מוצר</h4>
                  <p>{popUpData?.policyType}</p>
                </div>
                {/* 
                <div className="tm_info">
                  <h4>סוג פוליסה</h4>
                  <p>בריאות</p>
                </div> */}
              </div>
            </div>
            <div className="tm_policy_main">
              <div className="tm_policy_inn">
                <ol>
                  {popUpData &&
                    popUpData?.data &&
                    popUpData?.data[0]?.recommendation.map((data, index) => (
                      <>
                        <li>{data}</li>
                      </>
                    ))}
                  <h3>חיסכון משוער בשנה : ₪{popUpData?.data[0]?.saving}</h3>
                </ol>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Model 2 */}
      <Modal
        className="pecommendations-popup"
        open={openReccomendation}
        onClose={handleClose}
      >
        <Box sx={modalStyle}>
          <div className="m-close1">
            <img onClick={() => handleClose()} src={closeIcon} alt="close" />
          </div>
          <div className="m-header">
            <div className="m-container">
              <h2 className="m-summary-title">השוואת הצעות מכל חברות הביטוח</h2>
              <div className="m-summary-subtext">
                <p>
                  <span>
                    במסך הבא תוכלו לבצע השוואת הצעות ביטוח מכל חברות הביטוח
                    במקום אחד.
                  </span>
                  <br />
                  <span>
                    לפניכם פוליסת הביטוח הנוכחית שלכם על כל פרטיה, מתחתיה אפשרות
                    להשוואה אל מול המוצרים המובילים בשוק
                  </span>
                  <br />
                  <span>
                    המצב הקיים מייצג השוואה לפוליסה הקיימת שלכם, ישנה אפשרות
                    לערוך או לשנות את הכיסויים בהתאם לבחירה.
                  </span>
                </p>
                <div className="m-summary-text">
                  <p>הפוליסה הנוכחית: </p>
                </div>
              </div>
              <div class="m-policy-card">
                <div class="m-logo">
                  <img src={logo} alt="ביטוח ישיר" />
                </div>
                <div class="m-policy-cell">
                  <div class="m-detail">
                    <div class="m-label">מספר פוליסה</div>
                    <div class="m-value">
                      {popUpData?.policyNumber?.replace(/\D/g, "")}
                    </div>
                  </div>
                  <div class="m-detail">
                    <div class="m-label">מוצר</div>
                    <div class="m-value">
                      {popUpDataDetails?.from == "pension"
                        ? popUpDataDetails?.policyDetails?.SUG_POLISA
                        : popUpDataDetails?.policyDetails?.PRODUCT_TYPE}
                    </div>
                  </div>
                  <div class="m-detail">
                    <div class="m-label">סוג פוליסה</div>
                    <div class="m-value">
                      {popUpDataDetails?.from == "pension"
                        ? popUpDataDetails?.policyDetails?.productTypeName
                        : popUpDataDetails?.policyDetails?.MAIN_BRANCH}
                    </div>
                  </div>
                </div>
                <div class="m-policy-cell">
                  <div class="m-detail">
                    <div class="m-label">תאריך התחלה</div>
                    <div class="m-value">
                      {popUpDataDetails?.from === "pension"
                        ? popUpDataDetails?.policyDetails
                            ?.TAARICH_HITZTARFUT_MUTZAR || "אין נתונים"
                        : (() => {
                            const covers =
                              popUpDataDetails?.policyDetails?.Covers || [];
                            const coverWithStartDate = covers.find(
                              (c) => !!c.START_DATE
                            );
                            return (
                              coverWithStartDate?.START_DATE || "אין נתונים"
                            );
                          })()}
                    </div>
                  </div>
                  <div class="m-detail">
                    <div class="m-label">פרמיה</div>
                    <div class="m-value">
                      {popUpDataDetails?.from === "pension"
                        ? (() => {
                            const pirtei =
                              popUpDataDetails?.policyDetails?.PirteiTaktziv ||
                              [];
                            const sum = pirtei.reduce((acc, item) => {
                              const value = parseFloat(
                                item?.HotzaotBafoalLehodeshDivoach
                                  ?.SACH_DMEI_BITUAH_SHENIGBOO || "0"
                              );
                              return acc + (isNaN(value) ? 0 : value);
                            }, 0);
                            return sum > 0 ? sum.toFixed(2) : "אין נתונים";
                          })()
                        : (() => {
                            const covers =
                              popUpDataDetails?.policyDetails?.Covers || [];
                            const sum = covers.reduce((acc, item) => {
                              const value = parseFloat(
                                item?.PREMIUME_AMOUNT_IN_NIS || "0"
                              );
                              return acc + (isNaN(value) ? 0 : value);
                            }, 0);
                            return sum > 0 ? sum.toFixed(2) : "אין נתונים";
                          })()}
                    </div>
                  </div>
                  <div class="m-detail">
                    <div class="m-label">כיסויים</div>
                    <div class="m-value">בריאות</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="m-ifram">
            <div className="m-container">
              <iframe
                src="https://trusty.co.il/insurance/health"
                width="100%"
                height="300px"
                style={{ border: "none" }}
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Modal Details recomendation */}
      <Modal
        open={openDetails}
        onClose={handleModalCloseDetails}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="tmMain" sx={style}>
          <div className="table_modal_main">
            <div className="tm_sticky">
              <div className="tm_logo">
                <span className="em_brand_info">
                  <img src={popUpData?.logo || defaultLogo} alt="brand logo" />
                </span>
                <span className="em_close">
                  <img
                    onClick={handleModalCloseDetails}
                    src={closeIcon}
                    alt="close"
                  />
                </span>
              </div>
              <div className="tm_info_main">
                <div className="tm_info">
                  <h4>מספר פוליסה</h4>
                  <p>{popUpData?.policyNumber?.replace(/\D/g, "")}</p>
                </div>
                <div className="tm_info">
                  <h4>מוצר</h4>
                  <p>{popUpData?.policyType}</p>
                </div>

                <div className="tm_info">
                  <h4>סוג פוליסה</h4>
                  <p>בריאות</p>
                </div>
              </div>
            </div>
            <div className="tm_policy_main">
              <div className="tm_policy_inn">
                <ol>
                  {popUpData &&
                    popUpData?.data &&
                    popUpData?.data[0]?.recommendation.map((data, index) => (
                      <>
                        <li>{data}</li>
                      </>
                    ))}
                  <h3>חיסכון משוער בשנה : ₪{popUpData?.data[0]?.saving}</h3>
                </ol>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default TableComponent;
